module.exports = __webpack_public_path__ + "img/invitation2.736ca3e0.png";